import { CUSTOM_SELECT } from '../classnames/custom-select';
import { HIDDEN } from '../classnames/design-system';
import {
  PRODUCT_SWITCHER,
  PRODUCT_SWITCHER_BOTTLE_CONTAINER,
  PRODUCT_SWITCHER_CONTAINER
} from '../classnames/product-switcher';
import { getPageQueryParam } from '../utils/get-page-url';

export default class ProductSwitcherHandler {
  switcherCards = [];

  getActiveProductId = () => (
    document.querySelector(`.${PRODUCT_SWITCHER_CONTAINER}:not(.${HIDDEN})`).dataset.productId
  );

  onChangeCard = (productId) => {
    const productCards = document.querySelectorAll(`.${PRODUCT_SWITCHER_CONTAINER}`);

    [...productCards].forEach((card) => {
      if (card.dataset.productId === productId) {
        card.classList.remove(HIDDEN);
      } else {
        card.classList.add(HIDDEN);
      }
    });
  };

  onChangeBottle = (productId) => {
    const bottles = document.querySelectorAll(`.${PRODUCT_SWITCHER_BOTTLE_CONTAINER}`);

    [...bottles].forEach((bottle) => {
      if (bottle.dataset.productId === productId) {
        bottle.classList.remove(HIDDEN);
      } else {
        bottle.classList.add(HIDDEN);
      }
    });
  };

  handleSwitcherClick = (e) => {
    const { productId } = e.currentTarget.dataset;

    this.onChangeCard(productId);
    this.onChangeBottle(productId);
  };

  initialize() {
    const [currentProductContainer] = document.querySelectorAll(`.${PRODUCT_SWITCHER}`);
    const switcherCards = document.querySelectorAll(`.${PRODUCT_SWITCHER}`);
    const initialVariantId = currentProductContainer
      ?.querySelector(`.${CUSTOM_SELECT}`)
      ?.querySelectorAll('option')[0].value || window.currentVariantStorage.state.currentVariant.variantId;
    const urlVariantId = getPageQueryParam('variant');
    const initialVariantData = window.variantDataSelector.getData(urlVariantId || initialVariantId);

    [...switcherCards].forEach((switcherCard) => {
      switcherCard.addEventListener('click', this.handleSwitcherClick);
    });

    window.currentVariantStorage.setCurrentVariant(initialVariantData);
    window.currentVariantStorage.setState({ currentVariant: initialVariantData, subscription: 'subscription' });
  }
}
